import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router";
import Select, { SingleValue } from "react-select";
import { getStateAll } from "../../../api/subject.service";
import roles from "../../../utils/roles.json";
import regions from "../../../utils/regions.json";
import { IReactSelect } from "../../../model/interface/keyValuePair";
import {
  addDistrict,
  addSchool,
  addUser,
  getMiniCRMDistricts,
} from "../../../api/miniCrm.service";

const ManageCrm: React.FC = (props: any) => {
  const defaultSelect = { label: "", value: 0 };
  const [states, setStates] = useState<Array<any>>([]);
  const [districts, setDistricts] = useState<Array<any>>([]);
  const [selectedState, setSelectedStates] =
    useState<IReactSelect>(defaultSelect);
  const [selectedDistrict, setSelectedDistrict] =
    useState<IReactSelect>(defaultSelect);
  const [selectedRole, setSelectedRole] = useState<IReactSelect>(defaultSelect);
  const [region, setRegion] = useState<Array<any>>([]);
  const [selectedRegion, setSelectedRegion] = useState<any>({
    label: "",
    value: "",
  });
  const [city, setCity] = useState<string>("");
  const [district, setDistrict] = useState<string>("");
  const [zip, setZip] = useState<string>("");
  const [school, setSchool] = useState<string>("");
  const [fName, setFName] = useState<string>("");
  const [lName, setLName] = useState<string>("");
  const [uName, setUName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<any>();
  const [passwordConfirm, setConfirmPassword] = useState<any>();
  const [type] = useState<number>(
    window.location.pathname.includes("user")
      ? 1
      : window.location.pathname.includes("school")
      ? 2
      : window.location.pathname.includes("district")
      ? 3
      : 0
  );

  useEffect(() => {
    getStates();
  }, []);

  const getStates = async () => {
    const resp: any = await getStateAll(9999, 1);
    if (resp && resp.data) {
      setStates(
        resp?.data?.data?.map((ds) => ({
          label: ds.name,
          value: ds.stateId,
        }))
      );
    }
  };

  const onStateChange = async (e) => {
    setSelectedStates(e);

    const regionsData: any = regions.filter((ds) => ds.stateId === e.value);
    if (
      regionsData &&
      regionsData.length &&
      regionsData[0].regions &&
      regionsData[0].regions.length
    ) {
      setRegion(regionsData[0].regions);
    } else {
      setSelectedRegion({ label: "", value: "" });
      setRegion([]);
    }

    const resp = await getMiniCRMDistricts({
      stateId: e.value,
      region: "",
      districtId: 0,
      districtName: "",
      orderByColumn: "",
      sortDir: "",
      pageSize: 9999,
      pageNumber: 1,
    });

    if (resp && resp.data && resp.data.data) {
      setDistricts(
        resp.data.data.map((ds) => ({ label: ds.name, value: ds.districtId }))
      );
    }
  };

  const handleSubmit = async () => {
    try {
      if (type === 1) {
        const resp = await addUser({
          username: uName,
          firstName: fName,
          lastName: lName,
          email: email,
          password: passwordConfirm,
          stateId: selectedState.value,
          stateName: selectedState.label,
          regionId: selectedRegion.value,
          regionName: selectedRegion.label,
          districtId: selectedDistrict.value,
          districtName: selectedDistrict.label,
          roleId: selectedRole.value,
          updatedByUser: props?.profile?.userId,
        });

        if (resp && resp.data) {
          toast.success("User added successfully");
        } else {
          toast.error("Something went wrong");
        }
      }

      if (type === 2) {
        const resp = await addSchool({
          name: school,
          stateId: selectedState.value,
          stateName: selectedState.label,
          regionId: selectedRegion.value,
          regionName: selectedRegion.label,
          districtId: selectedDistrict.value,
          districtName: selectedDistrict.label,
          city: city,
          zip: zip,
        });
        if (resp && resp.data) {
          toast.success("School added successfully");
        } else {
          toast.error("Something went wrong");
        }
      }

      if (type === 3) {
        const resp = await addDistrict({
          districtName: district,
          stateId: selectedState.value,
          stateName: selectedState.label,
          regionId: selectedRegion.value,
          regionName: selectedRegion.label,
          city: city,
          zip: zip,
        });
        if (resp && resp.data) {
          toast.success("District added successfully");
        } else {
          toast.error("Something went wrong");
        }
      }
    } catch (e) {
      toast.error("Something went wrong");
    }
  };

  const handleSelectedDistrict = (option: SingleValue<IReactSelect> | null) => {
    if (option) {
      setSelectedDistrict(option);
    }
  };

  const handleSelectedRole = (option: SingleValue<IReactSelect> | null) => {
    if (option) {
      setSelectedRole(option);
    }
  };

  return (
    <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8 py-8 pt-0 pb-14 mt-7 ">
      <div className="relative  py-1">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-light text-gray-900">
            Add {type === 1 ? "User" : type === 2 ? "School" : "District"}
          </h3>
        </div>
        <div className="pt-3 ">
          <form id="users_form" className="p-3">
            {type === 1 && (
              <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-6">
                <div>
                  <label className="text-sm text-gray-700">State</label>
                  <Select
                    className="mt-1 text-sm"
                    options={states}
                    value={selectedState}
                    onChange={onStateChange}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Region</label>
                  <Select
                    className="mt-1 text-sm"
                    value={selectedRegion}
                    options={region}
                    onChange={setSelectedRegion}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">District</label>
                  <Select
                    className="mt-1 text-sm"
                    value={selectedDistrict}
                    options={districts}
                    onChange={handleSelectedDistrict}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Role</label>
                  <Select
                    className="mt-1 text-sm"
                    value={selectedRole}
                    options={roles}
                    onChange={handleSelectedRole}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">School</label>
                  <input
                    name="school"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setSchool(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">First Name</label>
                  <input
                    name="firstName"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setFName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Last Name</label>
                  <input
                    name="lastName"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setLName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Username</label>
                  <input
                    name="userName"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setUName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Email</label>
                  <input
                    name="email"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Password</label>
                  <input
                    name="password"
                    type="password"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-gray-700">
                    Confirm Password
                  </label>
                  <input
                    name="confirmPassword"
                    type="password"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />

                  {password &&
                    passwordConfirm &&
                    password !== passwordConfirm && (
                      <span className="text-red-500 pt-2">
                        Please Enter Valid Password
                      </span>
                    )}
                </div>
              </div>
            )}

            {type === 2 && (
              <div className="grid grid-cols-4 gap-6">
                <div>
                  <label className="text-sm text-gray-700">School</label>
                  <input
                    name="school"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setSchool(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">State</label>
                  <Select
                    className="mt-1 text-sm"
                    options={states}
                    value={selectedState}
                    onChange={onStateChange}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Region</label>
                  <Select
                    className="mt-1 text-sm"
                    value={selectedRegion}
                    options={region}
                    onChange={setSelectedRegion}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">District</label>
                  <Select
                    className="mt-1 text-sm"
                    value={selectedDistrict}
                    options={districts}
                    onChange={handleSelectedDistrict}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">City</label>
                  <input
                    name="school"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Zip</label>
                  <input
                    name="school"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setZip(e.target.value)}
                  />
                </div>
              </div>
            )}

            {type === 3 && (
              <div className="grid grid-cols-4 gap-6">
                <div>
                  <label className="text-sm text-gray-700">District</label>
                  <input
                    name="district"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setDistrict(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">State</label>
                  <Select
                    className="mt-1 text-sm"
                    options={states}
                    value={selectedState}
                    onChange={onStateChange}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Region</label>
                  <Select
                    className="mt-1 text-sm"
                    value={selectedRegion}
                    options={region}
                    onChange={setSelectedRegion}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#B3B3B3",
                        primary: "#041E42",
                      },
                    })}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        background:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#1A1C23"
                            : "white",
                        borderColor:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "#6B7280"
                            : "#D1D5DB",
                        borderWidth: "1px",
                        "&:hover": {
                          borderColor:
                            state.isFocused &&
                            document.getElementsByClassName("dark")?.length > 0
                              ? "#6b7280"
                              : state.isFocused
                              ? "#4c5563"
                              : "",
                        },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "#374051",
                      }),
                      input: (base) => ({
                        ...base,
                        color:
                          document.getElementsByClassName("dark")?.length > 0
                            ? "white"
                            : "",
                      }),
                    }}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">City</label>
                  <input
                    name="school"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-700">Zip</label>
                  <input
                    name="school"
                    type="text"
                    autoComplete="off"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    onChange={(e) => setZip(e.target.value)}
                  />
                </div>
              </div>
            )}

            <div className="flex justify-start  mt-5">
              <button
                type="button"
                onClick={() => handleSubmit()}
                className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
              >
                <span>Add</span>
              </button>
              <Link
                type="button"
                to={"/crm"}
                className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
              >
                <span>Cancel</span>
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(ManageCrm);
